import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { POSContentComponent } from './pos-content/pos-content.component';
import { VideoOverlayComponent } from './video-overlay/video-overlay.component';
import { ParticleEffectsOverlayComponent } from './particle-effects-overlay/particle-effects-overlay.component';
import { effectComponents } from './particle-effects-overlay/particle-effects';

export const components: any[] = [
  HeaderComponent,
  FooterComponent,
  POSContentComponent,
  VideoOverlayComponent,
  ParticleEffectsOverlayComponent,
  ...effectComponents,
];

export * from './header/header.component';
export * from './footer/footer.component';
export * from './privacy/privacy-notice.component';
